import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Button, Dialog, DialogActions, DialogContent, Theme as MuiTheme,
    DialogContentText, DialogTitle, Alert, Paper, Typography
} from '@mui/material';
import Draggable from 'react-draggable';
import { RateVersionDuplicationForm } from './RateVersionDuplicationForm';
import { duplicateRateVersion, RateVersion } from './RateVersionApiEndpoints';
//@ts-ignore
import { useResponsive } from 'lib/useResponsive';
import { useTranslation } from "react-i18next";
import { useTheme } from '@mui/material/styles';
//@ts-ignore
import { dateFormatter } from "lib/Formatters";

function PaperComponent(props: any) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export interface RateVersionDuplicationDialogProps {
    open: boolean;
    itemToEdit: any;
    onCancel: any;
    rateVersions: any;
    onSave: any;
    onError: any;
}

interface CustomInstanceOfMuiTheme extends MuiTheme {
    props: any;
}

export default function RateVersionDuplicationDialog(props: Readonly<RateVersionDuplicationDialogProps>) {
    const { t } = useTranslation();
    const [saving, setSaving] = React.useState(false);
    const [versionOverlap, setVersionOverlap] = React.useState(0);
    const [dialogSubmit, setDialogSubmit] = useState(0);
    const { isMobile } = useResponsive();
    const theme = useTheme<CustomInstanceOfMuiTheme>();
    const rateVersions = props.rateVersions;

    const handleCancel = () => {
        props.onCancel();
    };


    const handleSave = () => {
        setDialogSubmit(dialogSubmit + 1);
    };

    return (
        <>
            {props.open &&
                <Dialog
                    fullScreen={isMobile}
                    fullWidth={true}
                    maxWidth={"md"}
                    open={props.open}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {t("Are you sure you want to duplicate '" + props.itemToEdit.name + "' rate version?")}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ pb: 2 }}>     
                            <Typography variant="body1">{t("Please provide a name and select a date range for the duplicated version.")}</Typography>
                        </DialogContentText>
                        <RateVersionDuplicationForm
                            itemToEdit={props.itemToEdit}
                            dialogSubmit={dialogSubmit}
                            setVersionOverlap={setVersionOverlap}
                            rateVersions={rateVersions}
                            onSubmit={async (values: RateVersion) => {
                                setSaving(true);
                                try {
                                    let data = await duplicateRateVersion(values);

                                    if (data) {
                                        props.onSave(data);
                                    }
                                } finally {
                                    setSaving(false);
                                }
                            }}
                            onError={(error: any) => {
                                props.onError(error);

                                setSaving(false);
                            }}
                        />
                    </DialogContent>
                    {versionOverlap > 0 && (
                        <Alert severity="warning">{t("Rate version cannot overlap with existing version(s).")} <br />
                            {rateVersions?.map((item: RateVersion) => (
                                <li key={item.id}>
                                    {dateFormatter(new Date(item.startDate), true)} to {dateFormatter(new Date(item.endDate), true)}
                                </li>                      
                            ))}   
                        </Alert>
                    )}                                     
                    <DialogActions>
                        <div style={{flex: '1 0 0'}} />
                        <Button autoFocus onClick={handleCancel} variant={theme.props?.CancelButton?.variant || "outlined"} color={theme.props?.CancelButton?.color}>
                            {t('Cancel')}
                        </Button>
                        <LoadingButton
                            loading={saving}
                            onClick={handleSave}
                            variant="contained"
                            disabled={versionOverlap > 0}
                        >
                            {t('Duplicate')}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}